export default function FoldersIcon({ className }: { className?: string }) {
  return (
    <svg
      className={` ${className}`}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.06445 4.18693C4.06445 3.42143 4.06445 3.03868 4.22291 2.7463C4.36229 2.48912 4.5847 2.28002 4.85825 2.14898C5.16923 2 5.57634 2 6.39055 2H9.16899C9.69085 2 9.95178 2 10.1821 2.0747C10.3859 2.14077 10.5714 2.24858 10.7254 2.39034C10.8994 2.55065 11.0161 2.77007 11.2495 3.2089L12.0604 4.73366H15.1134C16.3347 4.73366 16.9454 4.73366 17.4119 4.95712C17.8222 5.15369 18.1558 5.46734 18.3649 5.85311C18.6026 6.29169 18.6026 6.86581 18.6026 8.01405V11.0211C18.6026 12.1693 18.6026 12.7434 18.3649 13.182C18.1558 13.5678 17.8222 13.8814 17.4119 14.078C17.1517 14.2027 16.8466 14.2578 16.4158 14.2821"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.39439 7.70632L8.5835 6.18156C8.35012 5.74273 8.23343 5.5233 8.05934 5.363C7.90539 5.22124 7.71984 5.11342 7.51613 5.04736C7.28576 4.97266 7.02483 4.97266 6.50298 4.97266H3.72453C2.91032 4.97266 2.50322 4.97266 2.19223 5.12163C1.91868 5.25267 1.69628 5.46177 1.55689 5.71896C1.39844 6.01134 1.39844 6.39409 1.39844 7.15958V7.70632M1.39844 7.70632H12.4474C13.6687 7.70632 14.2794 7.70632 14.7458 7.92978C15.1562 8.12634 15.4898 8.43999 15.6989 8.82577C15.9365 9.26434 15.9365 9.83846 15.9365 10.9867V13.9937C15.9365 15.142 15.9365 15.7161 15.6989 16.1547C15.4898 16.5405 15.1562 16.8541 14.7458 17.0507C14.2794 17.2741 13.6687 17.2741 12.4474 17.2741H4.88758C3.66627 17.2741 3.05561 17.2741 2.58913 17.0507C2.1788 16.8541 1.84519 16.5405 1.63612 16.1547C1.39844 15.7161 1.39844 15.142 1.39844 13.9937V7.70632Z"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const displayName = "FoldersIcon";
